import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "/hero-kitchen.jpg";

export const Hero = () => (
  <section
    id="top"
    data-testid="hero-section"
    className="relative min-h-[92vh] flex items-end overflow-hidden grain"
  >
    <div className="absolute inset-0">
      <img
        src={HERO_IMG}
        alt="The Monochrome Island Kitchen — built by Golden Mile Interiors"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/65" />
      <div className="absolute inset-x-0 bottom-0 h-56 bg-gradient-to-t from-[#120E0B] to-transparent" />
    </div>
    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pb-20 pt-44 w-full">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="section-label"
        data-testid="hero-label"
      >
        Bespoke Cabinet Makers · Est. 2026
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight text-cream max-w-3xl mt-6"
        data-testid="hero-heading"
      >
        Cabinetry worthy of the <span className="italic text-brass">Golden Mile</span>
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2 }}
        className="text-base md:text-lg text-cream-muted max-w-xl mt-6 leading-relaxed"
        data-testid="hero-subheading"
      >
        Precision-crafted kitchens, wardrobes and living-space joinery — designed,
        machined and fitted by our own workshop, never subcontracted.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.3 }}
        className="flex flex-wrap gap-4 mt-10"
      >
        <a
          href="#quote"
          data-testid="hero-cta-quote"
          className="inline-flex items-center gap-2 bg-brass text-espresso-900 font-semibold px-7 py-3.5 hover:bg-brass-hover transition-colors"
        >
          Start Your Project <ArrowRight size={16} />
        </a>
        <a
          href="#gallery"
          data-testid="hero-cta-gallery"
          className="inline-flex items-center gap-2 border border-cream/30 text-cream px-7 py-3.5 hover:border-brass hover:text-brass transition-colors"
        >
          View Our Work
        </a>
      </motion.div>
    </div>
  </section>
);
